module.exports = __webpack_public_path__ + "img/introduceOne.511efa4.png";